import queryString from 'query-string';
import { get } from './apiUtils';

const defaultUrl = '/SubstanceActions/';

export default {
  getSubstanceActions: ({ id, query } = {}) =>
    get(`${defaultUrl}${id || ''}${query ? '?'.concat(queryString.stringify(query)) : ''}`),
};
